var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.e{fill:#fff;}.a{opacity:0;}.b{fill:#bdedf8;}.b,.c,.d,.e{fill-rule:evenodd;}.c{fill:#428bca;}.d{fill:#66ceef;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15656 12708)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 80,
    height: 80,
    transform: "translate(-15656 -12708)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16994.461 -14726.517)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1395.838,2033.83l-5.233-3.005-29.83,17.212,5.2,3.006Z",
    transform: "translate(0.069 0.067)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1361.576,2048.1l4.468,2.572,29.1-16.78-4.468-2.571-29.1,16.778Zm4.468,3.382a.412.412,0,0,1-.191-.052l-5.2-3.005a.434.434,0,0,1-.191-.325.441.441,0,0,1,.191-.329l29.831-17.209a.389.389,0,0,1,.382,0l5.2,3.009a.369.369,0,0,1,0,.647l-29.831,17.213A.42.42,0,0,1,1366.044,2051.487Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1365.981,2047.966l-5.2-3.006-.033,35.859,5.233,3.008Z",
    transform: "translate(0.063 3.145)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1361.2,2080.671l4.465,2.572v-34.993l-4.434-2.574-.031,35Zm4.849,3.6a.411.411,0,0,1-.191-.049l-5.2-3.007a.359.359,0,0,1-.191-.327v-35.858a.441.441,0,0,1,.191-.329.408.408,0,0,1,.382,0l5.2,3.009a.356.356,0,0,1,.192.325v35.86a.424.424,0,0,1-.192.325A.419.419,0,0,1,1366.044,2084.267Z",
    transform: "translate(0 3.078)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1394.908,2033.293l-29.862,17.214v35.86l29.831-17.213Z",
    transform: "translate(0.999 0.604)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1365.5,2050.789v34.994l29.064-16.78.032-34.992-29.1,16.778Zm-.383,36.018a.389.389,0,0,1-.191-.051.349.349,0,0,1-.193-.323v-35.86a.427.427,0,0,1,.193-.325l29.863-17.209a.326.326,0,0,1,.351,0,.353.353,0,0,1,.191.322v35.861a.356.356,0,0,1-.191.325l-29.831,17.212A.419.419,0,0,1,1365.115,2086.807Z",
    transform: "translate(0.93 0.538)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1391.3,2055.148l-.032,6.266a1.635,1.635,0,0,1-.733,1.3l-22.239,12.825c-.414.24-.734.045-.734-.434v-11.215l.257-.35c.8-1.126,1.913-1.749,2.711-1.522l7.4,2.147c.766.22,1.788-.329,2.617-1.373l5.583-7.187c.861-1.075,1.946-1.621,2.68-1.349Z",
    transform: "translate(1.546 5.154)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1368.013,2064.081l-.033,11.09c0,.1.033.156.064.163,0,0,.032,0,.127-.055l22.237-12.823a1.339,1.339,0,0,0,.575-.975v-6l-2.233-.808c-.575-.21-1.532.309-2.233,1.229l-5.615,7.191c-.894,1.174-2.074,1.765-3,1.5l-7.433-2.147c-.606-.182-1.6.4-2.3,1.378l-.158.259Zm.032,12a.67.67,0,0,1-.384-.1.909.909,0,0,1-.415-.811v-11.216a.512.512,0,0,1,.065-.218l.256-.352c.926-1.27,2.169-1.937,3.126-1.662l7.434,2.15c.606.166,1.5-.338,2.2-1.243l5.582-7.188c.957-1.211,2.2-1.805,3.1-1.471l2.488.889a.4.4,0,0,1,.224.354v6.267a2.075,2.075,0,0,1-.926,1.625l-22.237,12.825A1.085,1.085,0,0,1,1368.045,2076.084Z",
    transform: "translate(1.478 5.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1391.3,2058.645l-2.488-.893c-.734-.271-1.819.274-2.68,1.35l-5.583,7.187c-.829,1.044-1.851,1.593-2.617,1.372l-7.4-2.146c-.8-.229-1.914.4-2.711,1.522l-.257.349v-15.57l23.738-13.691Z",
    transform: "translate(1.546 1.657)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1370.245,2065.16a1.717,1.717,0,0,1,.447.061l7.434,2.147c.606.176,1.5-.335,2.2-1.24l5.582-7.188c.957-1.211,2.2-1.805,3.1-1.471l1.978.711V2038.84l-22.97,13.259v14.265a3.164,3.164,0,0,1,2.232-1.2Zm8.1,2.993a1.636,1.636,0,0,1-.447-.064l-7.433-2.147c-.606-.184-1.6.4-2.3,1.378l-.254.354a.37.37,0,0,1-.415.138.366.366,0,0,1-.256-.359v-15.57a.358.358,0,0,1,.193-.326l23.738-13.69a.381.381,0,0,1,.382,0,.428.428,0,0,1,.191.325l-.032,20.52a.383.383,0,0,1-.16.307.341.341,0,0,1-.319.048l-2.489-.9c-.575-.2-1.532.307-2.233,1.229l-5.615,7.191A3.53,3.53,0,0,1,1378.349,2068.154Z",
    transform: "translate(1.478 1.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1382.111,2044.246c2.137-1.228,3.86-.23,3.86,2.229a8.5,8.5,0,0,1-3.86,6.672c-2.137,1.228-3.862.233-3.862-2.227A8.5,8.5,0,0,1,1382.111,2044.246Z",
    transform: "translate(3.874 2.875)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1382.174,2044.313Zm1.722-.15a3.17,3.17,0,0,0-1.532.475h0a8.145,8.145,0,0,0-3.669,6.349,2.374,2.374,0,0,0,.957,2.173,2.319,2.319,0,0,0,2.331-.27,8.145,8.145,0,0,0,3.669-6.347,2.355,2.355,0,0,0-.927-2.172,1.718,1.718,0,0,0-.829-.207Zm-3.445,9.955a2.343,2.343,0,0,1-1.181-.311,3.03,3.03,0,0,1-1.307-2.82,8.9,8.9,0,0,1,4.02-7,2.723,2.723,0,0,1,4.434,2.556,8.938,8.938,0,0,1-4.053,7A3.842,3.842,0,0,1,1380.451,2054.119Z",
    transform: "translate(3.811 2.808)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.2c27707e1516f2e47fac32a721c79bca.svg";
export { ForwardRef as ReactComponent };